import { useState } from 'react';
import { toast } from 'sonner';
import { useUsersClient } from '@/Hooks/ClientHooks';
import UIStrings from '@/Utils/UIStrings';

interface UseResendEmailPanelStateInterface {
    resendHandler: () => Promise<void>;
    resendButtonLoading: boolean;
}

function useResendEmailPanelState(): UseResendEmailPanelStateInterface {
    const client = useUsersClient();
    const [resendButtonLoading, setResendButtonLoading] = useState<boolean>(false);

    const resendHandler = async () => {
        try {
            setResendButtonLoading(true);
            await client.sendVerificationEmailAsync();
            toast.success(UIStrings.VerificationEmailSent);
        } catch (error) {
            toast.error(UIStrings.AnErrorOccurredPleaseTryAgain);
        }
        setResendButtonLoading(false);
    };

    return { resendHandler, resendButtonLoading };
}

export default useResendEmailPanelState;
